import { getApiUrl } from "@dashboard/config";

const TOKEN_KEY = "saleor_at";
const REFRESH_TOKEN_KEY = "saleor_rt";
const CSRF_TOKEN_KEY = "saleor_ct";
const USER_KEY = "saleor_user";

export const getAccessToken = () => localStorage.getItem(TOKEN_KEY);
export const setAccessToken = (token: string) => localStorage.setItem(TOKEN_KEY, token);
export const removeAccessToken = () => localStorage.removeItem(TOKEN_KEY);

export const getRefreshToken = () => localStorage.getItem(REFRESH_TOKEN_KEY);
export const setRefreshToken = (token: string) => localStorage.setItem(REFRESH_TOKEN_KEY, token);
export const removeRefreshToken = () => localStorage.removeItem(REFRESH_TOKEN_KEY);

export const getCsrfToken = () => localStorage.getItem(CSRF_TOKEN_KEY);
export const setCsrfToken = (token: string) => localStorage.setItem(CSRF_TOKEN_KEY, token);
export const removeCsrfToken = () => localStorage.removeItem(CSRF_TOKEN_KEY);

export const getUser = () => {
  const user = localStorage.getItem(USER_KEY);

  return user ? JSON.parse(user) : null;
};
export const setUser = (user: any) => localStorage.setItem(USER_KEY, JSON.stringify(user));
export const removeUser = () => localStorage.removeItem(USER_KEY);

export async function fetchGraphQL(query: string, variables: any = {}) {
  const response = await fetch(getApiUrl(), {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...(getAccessToken() ? { Authorization: `Bearer ${getAccessToken()}` } : {}),
    },
    body: JSON.stringify({
      query,
      variables,
    }),
  });

  return response.json();
}

export const authService = {
  getAccessToken,
  setAccessToken,
  removeAccessToken,
  getRefreshToken,
  setRefreshToken,
  removeRefreshToken,
  getCsrfToken,
  setCsrfToken,
  removeCsrfToken,
  getUser,
  setUser,
  removeUser,
  clearTokens: () => {
    removeAccessToken();
    removeRefreshToken();
    removeCsrfToken();
    removeUser();
  },
};
